import { provideState } from '@ngrx/store';

import { sheetViewReducer } from './sheet-view.reducer';
import { sheetViewStateKey } from './sheet-view.state';
import { tabControllerReducer } from './store/option-group-tab-controller-index-keeper.reducer';
import { tabControllerStateKey } from './store/option-group-tab-controller-index-keeper.state';

export function provideSheetViewCore() {
    return [provideState(sheetViewStateKey, sheetViewReducer), provideState(tabControllerStateKey, tabControllerReducer)];
}
